import styled from 'styled-components';

const Container = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-un02xd-0"
})(["background-color:", ";z-index:", ";position:fixed;top:0;right:0;bottom:0;left:0;overflow:hidden;display:flex;align-items:center;justify-content:center;@media (prefers-reduced-motion:no-preference){transition:opacity ", "ms ease-in-out;}opacity:0;opacity:", ";"], ({
  theme
}) => theme.modal.overlay, ({
  theme
}) => theme.modal.zIndex, ({
  $fadeDuration
}) => $fadeDuration, ({
  $transitionState
}) => ({
  entering: 0,
  entered: 1,
  exiting: 0,
  exited: 0,
  unmounted: 0
})[$transitionState]);
Container.displayName = 'Container';
const OuterWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-un02xd-1"
})(["box-sizing:border-box;outline:none;width:fit-content;max-width:80%;overflow:hidden;border-radius:", ";@media (prefers-reduced-motion:no-preference){transition:all 100ms ease-in-out;}transform:", ";"], ({
  theme
}) => theme.modal.radius, ({
  $transitionState
}) => ({
  entering: 'scale(0.95)',
  entered: 'none',
  exiting: 'none',
  exited: 'none',
  unmounted: 'none'
})[$transitionState]);
OuterWrapper.displayName = 'OuterWrapper';
const Wrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-un02xd-2"
})(["box-sizing:border-box;word-wrap:break-word;"]);
Wrapper.displayName = 'Wrapper';
const Header = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-un02xd-3"
})(["background:", ";border-bottom:thin solid ", ";padding:12px 14px;display:flex;justify-content:space-between;"], ({
  theme
}) => theme.modal.header.bg, ({
  theme
}) => theme.modal.header.borderColor);
Header.displayName = 'Header';
const Content = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-un02xd-4"
})(["background:", ";padding:", ";overflow-y:auto;max-height:calc(100vh - 13rem);"], ({
  theme
}) => theme.modal.content, ({
  $padding,
  theme
}) => $padding ? theme.spacing[$padding] : `${theme.spacing.large} ${theme.spacing.base}`);
Content.displayName = 'Content';
const Footer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-un02xd-5"
})(["background:", ";padding:12px 14px;display:flex;justify-content:flex-end;> *{margin-inline-end:", ";}> *:last-child{margin-inline-end:0;}border-top:1px solid ", ";"], ({
  theme
}) => theme.modal.footer.bg, ({
  theme
}) => theme.spacing.mini, ({
  theme
}) => theme.modal.footer.borderColor);
Footer.displayName = 'Footer';

export { Container as C, Footer as F, Header as H, OuterWrapper as O, Wrapper as W, Content as a };
//# sourceMappingURL=Modal.styles-Bjk0G7k_.js.map
